import { Link, useLocation } from "react-router-dom";

export function Header() {
  const location = useLocation();

  const navItems = [
    { path: "/writing", label: "Writing" },
    { path: "/projects", label: "Projects" },
    { path: "/about", label: "About" },
  ];

  return (
    <header className="border-b border-border-subtle">
      <div className="mx-auto max-w-4xl px-8 py-5 flex items-center justify-between">
        <Link to="/" className="block">
          <img src="/signature.png" alt="Maxim Kraft" className="h-8 w-auto" />
        </Link>
        <nav className="flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-[13px] tracking-wide transition-colors ${
                location.pathname === item.path || location.pathname.startsWith(item.path + "/")
                  ? "text-primary"
                  : "text-text-secondary hover:text-primary"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
